/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayStatsResponse
 */
export interface PlayStatsResponse {
    /**
     * Gross XP earned from all sources in the window (sum of earn/DEBIT transactions). Excludes XP spent on token loads and admin removals, so it is never negative. The net balance is User.experiencePoints, not this.
     * @type {number}
     * @memberof PlayStatsResponse
     */
    xpOverall?: number;
    /**
     * Gross XP earned from gaming activities only (earn/DEBIT transactions with a gaming subject).
     * @type {number}
     * @memberof PlayStatsResponse
     */
    xpGaming?: number;
    /**
     * Gross XP earned from non-gaming activities (xpOverall - xpGaming).
     * @type {number}
     * @memberof PlayStatsResponse
     */
    xpOther?: number;
    /**
     * Time played in minutes
     * @type {number}
     * @memberof PlayStatsResponse
     */
    timePlayed?: number;
    /**
     * Number of unique games played
     * @type {number}
     * @memberof PlayStatsResponse
     */
    gamesPlayed?: number;
    /**
     * The time filter applied
     * @type {string}
     * @memberof PlayStatsResponse
     */
    timeFilter?: string;
    /**
     * Start date of the filter period (EST)
     * @type {Date}
     * @memberof PlayStatsResponse
     */
    startDate?: Date;
    /**
     * End date of the filter period (EST)
     * @type {Date}
     * @memberof PlayStatsResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the PlayStatsResponse interface.
 */
export function instanceOfPlayStatsResponse(value: object): value is PlayStatsResponse {
    return true;
}

export function PlayStatsResponseFromJSON(json: any): PlayStatsResponse {
    return PlayStatsResponseFromJSONTyped(json, false);
}

export function PlayStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'xpOverall': json['xpOverall'] == null ? undefined : json['xpOverall'],
        'xpGaming': json['xpGaming'] == null ? undefined : json['xpGaming'],
        'xpOther': json['xpOther'] == null ? undefined : json['xpOther'],
        'timePlayed': json['timePlayed'] == null ? undefined : json['timePlayed'],
        'gamesPlayed': json['gamesPlayed'] == null ? undefined : json['gamesPlayed'],
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function PlayStatsResponseToJSON(json: any): PlayStatsResponse {
    return PlayStatsResponseToJSONTyped(json, false);
}

export function PlayStatsResponseToJSONTyped(value?: PlayStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xpOverall': value['xpOverall'],
        'xpGaming': value['xpGaming'],
        'xpOther': value['xpOther'],
        'timePlayed': value['timePlayed'],
        'gamesPlayed': value['gamesPlayed'],
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

